import {
  ChangeRoomStatusResult
} from '@hkm/components/Housekeeping/Batch/domain/interfaces';
import { Store } from '@hkm/store/interfaces/store';

export const selectChangeBatchRoomsStatusResult = (state: Store): ChangeRoomStatusResult[] | null  => state.housekeepingChangeBatchStatus.changeRoomsStatusResults;
export const selectIsChangeBatchStatusPending = (state: Store): boolean  => state.housekeepingChangeBatchStatus.isPending;



// WEBPACK FOOTER //
// ./src/components/Housekeeping/Batch/domain/selectors.ts